import { useAuthManager } from '@funtech-int/yango-shared';
import { useCallback } from 'react';

export function useNavigateToAuthorizationCallback() {
    const authManager = useAuthManager();

    return useCallback(
        (queryParams?: Record<string, string>) => {
            const url = new URL(window.location.href);

            if (queryParams) {
                Object.entries(queryParams).forEach(([key, value]) => {
                    url.searchParams.set(key, value);
                });
            }

            window.location.assign(authManager.getLoginUrl(url));
        },
        [authManager]
    );
}
